import { Fieldset } from "@circle-react-uikit/Fieldset";
import { usePaywallCheckoutContext } from "@circle-react/contexts/Paywalls/paywallCheckoutContext";
import type { CheckoutContextProps } from "@circle-react/contexts/Paywalls/paywallCheckoutContext";
import { useCallback } from "react";

import type { PaywallPrice } from "@/react/types/PaywallPrice";

import { PriceDescription } from "./PriceDescription";
import { RadioOption } from "./RadioOption";

interface PriceSelectorProps {
  useHooks?: () => Pick<
    CheckoutContextProps,
    "paywall" | "setSelectedPrice" | "isSelectedPrice" | "couponPreviewMutation"
  >;
}

export const PriceSelector = ({
  useHooks = usePaywallCheckoutContext,
}: PriceSelectorProps) => {
  const { paywall, setSelectedPrice, isSelectedPrice, couponPreviewMutation } =
    useHooks();

  const onPriceChangeHandler = useCallback(
    (priceId: number) => {
      setSelectedPrice(priceId);
    },
    [setSelectedPrice],
  );

  return (
    <Fieldset
      divProps={
        {
          className: "border border-primary rounded-lg divide-y flex flex-col",
          "data-testid": "upsell-price-selector",
        } as React.ComponentPropsWithoutRef<"div">
      }
      onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
        onPriceChangeHandler(Number(event.target.id))
      }
    >
      {paywall.prices.map((price: PaywallPrice) => (
        <RadioOption
          key={`paywall_price-${price.id}`}
          id={price.id.toString()}
          value={price.value}
          isSelected={isSelectedPrice(price)}
          label={
            <PriceDescription
              paywall={paywall}
              price={price}
              couponPreviewMutation={couponPreviewMutation}
            />
          }
          dataTestId="checkout-paywall-price-option"
        />
      ))}
    </Fieldset>
  );
};
